var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.75V14.75L29 14.75",
    stroke: "#6D31ED",
    strokeWidth: 1.44,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27L29 13.5L23 9L11 9L11 27",
    stroke: "#6D31ED",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.25V31.25L29 31.25V28.25",
    stroke: "#6D31ED",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7481 24V19.68H16.5721C16.6141 19.68 16.6701 19.682 16.7401 19.686C16.8121 19.688 16.8761 19.694 16.9321 19.704C17.1901 19.744 17.4011 19.829 17.5651 19.959C17.7311 20.089 17.8531 20.253 17.9311 20.451C18.0091 20.647 18.0481 20.866 18.0481 21.108C18.0481 21.35 18.0081 21.57 17.9281 21.768C17.8501 21.964 17.7281 22.127 17.5621 22.257C17.3981 22.387 17.1881 22.472 16.9321 22.512C16.8761 22.52 16.8121 22.526 16.7401 22.53C16.6681 22.534 16.6121 22.536 16.5721 22.536H15.5641V24H14.7481ZM15.5641 21.774H16.5361C16.5781 21.774 16.6241 21.772 16.6741 21.768C16.7241 21.764 16.7701 21.756 16.8121 21.744C16.9221 21.714 17.0071 21.664 17.0671 21.594C17.1271 21.522 17.1681 21.443 17.1901 21.357C17.2141 21.269 17.2261 21.186 17.2261 21.108C17.2261 21.03 17.2141 20.948 17.1901 20.862C17.1681 20.774 17.1271 20.695 17.0671 20.625C17.0071 20.553 16.9221 20.502 16.8121 20.472C16.7701 20.46 16.7241 20.452 16.6741 20.448C16.6241 20.444 16.5781 20.442 16.5361 20.442H15.5641V21.774ZM18.6505 24V19.68H20.0485C20.0825 19.68 20.1525 19.681 20.2585 19.683C20.3645 19.685 20.4665 19.692 20.5645 19.704C20.9125 19.746 21.2075 19.867 21.4495 20.067C21.6915 20.267 21.8755 20.521 22.0015 20.829C22.1275 21.137 22.1905 21.474 22.1905 21.84C22.1905 22.206 22.1275 22.543 22.0015 22.851C21.8755 23.159 21.6915 23.413 21.4495 23.613C21.2075 23.813 20.9125 23.934 20.5645 23.976C20.4665 23.988 20.3645 23.995 20.2585 23.997C20.1525 23.999 20.0825 24 20.0485 24H18.6505ZM19.4785 23.232H20.0485C20.1025 23.232 20.1755 23.231 20.2675 23.229C20.3595 23.225 20.4425 23.216 20.5165 23.202C20.7045 23.164 20.8575 23.076 20.9755 22.938C21.0955 22.8 21.1835 22.634 21.2395 22.44C21.2975 22.246 21.3265 22.046 21.3265 21.84C21.3265 21.624 21.2965 21.419 21.2365 21.225C21.1785 21.031 21.0895 20.867 20.9695 20.733C20.8495 20.599 20.6985 20.514 20.5165 20.478C20.4425 20.462 20.3595 20.453 20.2675 20.451C20.1755 20.449 20.1025 20.448 20.0485 20.448H19.4785V23.232ZM22.9102 24V19.68H25.5502V20.496H23.7262V21.432H25.1902V22.248H23.7262V24H22.9102Z",
    fill: "#6D31ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf_file.24719003395be472b4beeb1f343dfb11.svg";
export { ForwardRef as ReactComponent };